import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import IndirectUseSoldTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import indirectIcon from "../../../../../assets/design-revamp-company/category-icons/indirect-use-icon.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
const IndirectUseContents = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;
  return (
    <div className="use-sold-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={t("COMP_INDIRECT_TITLE")}
          isNormal={true}
          number={"16.2"}
          icon={indirectIcon}
        />
      </div>

      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`prod-indirectusesold-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <IndirectUseSoldTable productId={productId} />
        </TableLoadingWrapper>
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default IndirectUseContents;
